export const divisionsErrors = {
    archive: [
        "divisionActiveCoverageError",
        "divisionActiveCoverageAndClassError",
        "divisionActiveClassError"
    ]
};


// WEBPACK FOOTER //
// ./src/utils/enums/enumDivisionsErrors.js